import React, { useEffect, useState } from 'react';
import { VisitasMision } from './Jhimbo_visitas/VisitasMision';
import { VisitasUbicacion } from './Jhimbo_visitas/VisitasUbicacion';
import { VisitasPilares } from './Jhimbo_visitas/VisitasPilares';
import { VisitasSeguridad } from './Jhimbo_visitas/VisitasSeguridad';
import { VisitasEnvio } from './Jhimbo_visitas/VisitasEnvio';
import { VisitasHistoria } from './Jhimbo_visitas/VisitasHistoria';
import { useProveedorVisita, returnFullURL } from "../components";

export const Ubicacion_visitas = () => {
  const { callInformationCompany, nit } = useProveedorVisita() || {};

  const [company_us_data, setCompany_us_data] = useState({});
  const [company_main_data, setCompany_main_data] = useState({});

  const loadDataUs = async () => {
    const data_us = await callInformationCompany("us");
    const data_main = await callInformationCompany("main");

    setCompany_us_data(data_us);
    setCompany_main_data(data_main);
  };

  useEffect(() => {
    loadDataUs();
  }, []);

  return (
    <React.Fragment key={"nosotros_" + nit}>
      <VisitasHistoria infoCompany={company_us_data && company_us_data} />

      <VisitasUbicacion infoCompany={company_us_data && company_us_data} company_name={(company_main_data && company_main_data?.name) ?? "Sin nombre"} />

      <VisitasSeguridad infoCompany={company_us_data && company_us_data} />

      <VisitasPilares infoCompany={company_us_data && company_us_data} function_url={returnFullURL} />

      <VisitasEnvio infoCompany={company_us_data && company_us_data} />

      <VisitasMision infoCompany={company_us_data && company_us_data} />
    </React.Fragment>
  )
}
